import React from "react";

// ASSETS
import LogoDsu from "assets/svg/LogoDsu.svg";
import BannerElections from "assets/img/alegeri.banner_lung.jpg";
import animationData from "assets/animated/Arrow.json";
import YoutubeIcon from "assets/svg/YoutubeGrey.svg";
import FacebookIcon from "assets/svg/FacebookGrey.svg";
import InstagramIcon from "assets/svg/InstagramIcon.svg";
import SiglaISO from "assets/img/SiglaISO.jpg";
import SiglaSMC from "assets/img/SiglaSMC.jpg";
import RoundedQuearterCircle from "assets/svg/RoundedQuarterCircleGrey.svg";

// STYLES
import {
  BigContainer,
  GridContainer,
  Column,
  Row,
  MediumCard,
  FirstCard,
  SecondCard,
  ThirdCard,
  MiddleCard,
  TitleLarge,
  RoundedCircle,
  IconTextContainer,
  Icon,
  TitleMedium,
  FourthCard,
  Title,
  SocialIcon,
  ContactStyled,
  LinkWrapper,
  StyledLink,
  LinkWrapperFirstCard,
  WrapperRoundedCircle,
  ColumnSecondCard,
  HorizontalLine,
  RowSecondCard,
  CookiesWrapper,
  ColumnThirdCard,
  HorizontalLineThird,
  IconCard,
  RowThirdCard,
  ColumnOne,
  DsuWrapper,
  SocialWrapper,
  SiglaIcon,
  SocialCard,
} from "./FooterStyled";

// LIBRARIES
import Lottie from "lottie-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { IProps } from "./FooterModel";
import { appRoutes } from "config/AppRoutesConfig";
// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";

const Footer = (props: IProps) => {
  // PROPERTIES
  const { handleScrollToTop } = props;
  // LIBRARY CONSTANTS

  const isMobile = useMediaQuery({ maxWidth: 1024 });
  const isTablet = useMediaQuery({ minWidth: 1024, maxWidth: 1605 });

  const navigate = useNavigate();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const { t } = useTranslation();

  const lottieStyle = {
    width: !isMobile ? 144 : 84,
    height: !isMobile ? 144 : 84,
    transform: "rotate(180deg)",
  };

  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  const scrollToTop = () => {
    handleScrollToTop();
  };

  return (
    <>
      <BigContainer>
        
        <GridContainer>
          <Column>
            <Row>
              <FirstCard tabIndex={0}>
                <LinkWrapperFirstCard
                  href={"http://www.dsu.mai.gov.ro"}
                  target="_blank"
                  biggerCursor={biggerCursor}
                >
                  <IconTextContainer>
                    <Icon src={LogoDsu} alt="LogoDsu" />
                    <CustomText
                      type={TextType.H4bold}
                      text={t("components.footer.card1.DSU")}
                      color={COLORS.Yellow}
                    />
                  </IconTextContainer>
                </LinkWrapperFirstCard>
              </FirstCard>
              <SecondCard tabIndex={0}>
                <WrapperRoundedCircle>
                  <RoundedCircle src={RoundedQuearterCircle} />
                </WrapperRoundedCircle>
                <TitleLarge>
                  <CustomText
                    type={TextType.H3}
                    text={t("components.footer.card2.title")}
                    color={COLORS.Yellow}
                  />
                </TitleLarge>
                <RowSecondCard>
                  <ColumnSecondCard>
                    <LinkWrapper
                      biggerCursor={biggerCursor}
                      onClick={() => navigate(appRoutes.about)}
                    >
                      <CustomText
                        type={TextType.H4}
                        text={t("components.footer.card2.aboutDsu")}
                        color={COLORS.Cultured}
                      />
                    </LinkWrapper>
                    <LinkWrapper
                      onClick={() => navigate(appRoutes.dsuNumbers)}
                      biggerCursor={biggerCursor}
                    >
                      <CustomText
                        type={TextType.H4}
                        text={t("components.footer.card2.answers")}
                        color={COLORS.Cultured}
                      />
                    </LinkWrapper>

                    <LinkWrapper
                      onClick={() => navigate(appRoutes.news)}
                      biggerCursor={biggerCursor}
                    >
                      <CustomText
                        type={TextType.H4}
                        text={t("components.footer.card2.news")}
                        color={COLORS.Cultured}
                      />
                    </LinkWrapper>
                  </ColumnSecondCard>

                  <ColumnSecondCard>
                    <LinkWrapper
                      biggerCursor={biggerCursor}
                      onClick={() => navigate(appRoutes.legislation)}
                    >
                      <CustomText
                        type={TextType.H4}
                        text={t("components.footer.card2.legislation")}
                        color={COLORS.Cultured}
                      />
                    </LinkWrapper>
                    <LinkWrapper
                      onClick={() => navigate(appRoutes.dialog)}
                      biggerCursor={biggerCursor}
                    >
                      <CustomText
                        type={TextType.H4}
                        text={t("components.footer.card2.dialog")}
                        color={COLORS.Cultured}
                      />
                    </LinkWrapper>

                    <LinkWrapper
                      onClick={() => navigate(appRoutes.contact)}
                      biggerCursor={biggerCursor}
                    >
                      <CustomText
                        type={TextType.H4}
                        text={t("components.footer.card2.contact")}
                        color={COLORS.Cultured}
                      />
                    </LinkWrapper>
                  </ColumnSecondCard>
                  <ColumnSecondCard>
                    <LinkWrapper
                      biggerCursor={biggerCursor}
                      onClick={() => navigate(appRoutes.gdpr)}
                    >
                      <CustomText
                        type={TextType.H4}
                        text={t("components.footer.card2.gdpr")}
                        color={COLORS.Cultured}
                      />
                    </LinkWrapper>
                    <LinkWrapper
                      onClick={() =>
                        window.open(
                          "https://chestionare.mai.gov.ro/index.php/729914?lang=ro",
                          "_blank"
                        )
                      }
                      biggerCursor={biggerCursor}
                    >
                      <CustomText
                        type={TextType.H4}
                        text={t("components.footer.card2.opinion")}
                        color={COLORS.Cultured}
                      />
                    </LinkWrapper>
                  </ColumnSecondCard>
                </RowSecondCard>
                {isMobile && <HorizontalLine />}

                <CookiesWrapper onClick={() => navigate(appRoutes.cookies)}>
                  {!isMobile && <HorizontalLine />}
                  <CustomText
                    text={t("components.footer.card2.cookies")}
                    type={TextType.H5}
                    color={COLORS.Cultured}
                  />
                </CookiesWrapper>
              </SecondCard>
            </Row>
            <Row>
              {!isTablet ? (
                <ThirdCard tabIndex={0}>
                  <TitleLarge>
                    <CustomText
                      type={TextType.H3}
                      text={t("components.footer.card3.title")}
                      color={COLORS.Yellow}
                    />
                  </TitleLarge>
                  <RowThirdCard>
                    <ColumnThirdCard>
                      <LinkWrapper
                        href={"https://www.gov.ro/"}
                        biggerCursor={biggerCursor}
                        target="_blank"
                      >
                        <CustomText
                          type={TextType.H5}
                          text={t("components.footer.card3.GR")}
                          color={COLORS.Cultured}
                        />
                      </LinkWrapper>
                      <LinkWrapper
                        href={"https://aviatie.mai.gov.ro/"}
                        biggerCursor={biggerCursor}
                        target="_blank"
                      >
                        <CustomText
                          type={TextType.H5}
                          text={t("components.footer.card3.IGAM")}
                          color={COLORS.Cultured}
                        />
                      </LinkWrapper>
                      <LinkWrapper
                        href={"https://igi.mai.gov.ro"}
                        target="_blank"
                        biggerCursor={biggerCursor}
                      >
                        <CustomText
                          type={TextType.H5}
                          text={t("components.footer.card3.IGI")}
                          color={COLORS.Cultured}
                        />
                      </LinkWrapper>
                      <LinkWrapper
                        href={"https://www.igsu.ro"}
                        biggerCursor={biggerCursor}
                        target="_blank"
                      >
                        <CustomText
                          type={TextType.H5}
                          text={t("components.footer.card3.IGSU")}
                          color={COLORS.Cultured}
                        />
                      </LinkWrapper>
                    </ColumnThirdCard>

                    <ColumnThirdCard>
                      <LinkWrapper
                        href={"https://insp.gov.ro/"}
                        biggerCursor={biggerCursor}
                        target="_blank"
                      >
                        <CustomText
                          type={TextType.H5}
                          text={t("components.footer.card3.INSP")}
                          color={COLORS.Cultured}
                        />
                      </LinkWrapper>
                      <LinkWrapper
                        href={"https://www.mae.ro/"}
                        biggerCursor={biggerCursor}
                        target="_blank"
                      >
                        <CustomText
                          type={TextType.H5}
                          text={t("components.footer.card3.MAE")}
                          color={COLORS.Cultured}
                        />
                      </LinkWrapper>

                      <LinkWrapper
                        href={"https://www.mai.gov.ro/"}
                        biggerCursor={biggerCursor}
                        target="_blank"
                      >
                        <CustomText
                          type={TextType.H5}
                          text={t("components.footer.card3.MAI")}
                          color={COLORS.Cultured}
                        />
                      </LinkWrapper>
                      <LinkWrapper
                        href={"https://www.ms.ro/ro/"}
                        biggerCursor={biggerCursor}
                        target="_blank"
                      >
                        <CustomText
                          type={TextType.H5}
                          text={t("components.footer.card3.MS")}
                          color={COLORS.Cultured}
                        />
                      </LinkWrapper>
                    </ColumnThirdCard>

                    <ColumnThirdCard>
                      <LinkWrapper
                        href={"https://www.politiaromana.ro"}
                        biggerCursor={biggerCursor}
                        target="_blank"
                      >
                        <CustomText
                          type={TextType.H5}
                          text={t("components.footer.card3.POL")}
                          color={COLORS.Cultured}
                        />
                      </LinkWrapper>
                      <LinkWrapper
                        href={"https://www.presidency.ro/"}
                        biggerCursor={biggerCursor}
                        target="_blank"
                      >
                        <CustomText
                          type={TextType.H5}
                          text={t("components.footer.card3.PR")}
                          color={COLORS.Cultured}
                        />
                      </LinkWrapper>
                      <LinkWrapper
                        href={"http://www.salvamontromania.ro"}
                        biggerCursor={biggerCursor}
                        target="_blank"
                      >
                        <CustomText
                          type={TextType.H5}
                          text={t("components.footer.card3.SR")}
                          color={COLORS.Cultured}
                        />
                      </LinkWrapper>
                    </ColumnThirdCard>
                  </RowThirdCard>
                  {isMobile && <HorizontalLine />}

                  <CookiesWrapper>
                    <CustomText
                      text={"© " + t("components.footer.card3.DSU")}
                      type={TextType.H5}
                      color={COLORS.Cultured}
                    />
                    {!isMobile && <HorizontalLineThird />}
                  </CookiesWrapper>
                </ThirdCard>
              ) : (
                <>
                  <ColumnOne>
                    <ThirdCard tabIndex={0}>
                      <TitleLarge>
                        <CustomText
                          type={TextType.H3}
                          text={"Legaturi utile"}
                          color={COLORS.Yellow}
                        />
                      </TitleLarge>
                      <RowThirdCard>
                        <ColumnThirdCard>
                          <LinkWrapper
                            href={"https://www.gov.ro/"}
                            biggerCursor={biggerCursor}
                            target="_blank"
                          >
                            <CustomText
                              type={TextType.H5}
                              text={t("components.footer.card3.GR")}
                              color={COLORS.Cultured}
                            />
                          </LinkWrapper>
                          <LinkWrapper
                            href={"https://aviatie.mai.gov.ro/"}
                            biggerCursor={biggerCursor}
                            target="_blank"
                          >
                            <CustomText
                              type={TextType.H5}
                              text={t("components.footer.card3.IGAM")}
                              color={COLORS.Cultured}
                            />
                          </LinkWrapper>
                          <LinkWrapper
                            href={"https://igi.mai.gov.ro"}
                            target="_blank"
                            biggerCursor={biggerCursor}
                          >
                            <CustomText
                              type={TextType.H5}
                              text={t("components.footer.card3.IGI")}
                              color={COLORS.Cultured}
                            />
                          </LinkWrapper>
                          <LinkWrapper
                            href={"https://www.igsu.ro"}
                            biggerCursor={biggerCursor}
                            target="_blank"
                          >
                            <CustomText
                              type={TextType.H5}
                              text={t("components.footer.card3.IGSU")}
                              color={COLORS.Cultured}
                            />
                          </LinkWrapper>
                          <LinkWrapper
                            href={"https://www.politiaromana.ro"}
                            biggerCursor={biggerCursor}
                            target="_blank"
                          >
                            <CustomText
                              type={TextType.H5}
                              text={t("components.footer.card3.POL")}
                              color={COLORS.Cultured}
                            />
                          </LinkWrapper>
                          <LinkWrapper
                            href={"https://www.presidency.ro/"}
                            biggerCursor={biggerCursor}
                            target="_blank"
                          >
                            <CustomText
                              type={TextType.H5}
                              text={t("components.footer.card3.PR")}
                              color={COLORS.Cultured}
                            />
                          </LinkWrapper>
                        </ColumnThirdCard>

                        <ColumnThirdCard>
                          <LinkWrapper
                            href={"https://insp.gov.ro/"}
                            biggerCursor={biggerCursor}
                            target="_blank"
                          >
                            <CustomText
                              type={TextType.H5}
                              text={t("components.footer.card3.INSP")}
                              color={COLORS.Cultured}
                            />
                          </LinkWrapper>
                          <LinkWrapper
                            href={"https://www.mae.ro/"}
                            biggerCursor={biggerCursor}
                            target="_blank"
                          >
                            <CustomText
                              type={TextType.H5}
                              text={t("components.footer.card3.MAE")}
                              color={COLORS.Cultured}
                            />
                          </LinkWrapper>

                          <LinkWrapper
                            href={"https://www.mai.gov.ro/"}
                            biggerCursor={biggerCursor}
                            target="_blank"
                          >
                            <CustomText
                              type={TextType.H5}
                              text={t("components.footer.card3.MAI")}
                              color={COLORS.Cultured}
                            />
                          </LinkWrapper>
                          <LinkWrapper
                            href={"https://www.ms.ro/ro/"}
                            biggerCursor={biggerCursor}
                            target="_blank"
                          >
                            <CustomText
                              type={TextType.H5}
                              text={t("components.footer.card3.MS")}
                              color={COLORS.Cultured}
                            />
                          </LinkWrapper>
                          <LinkWrapper
                            href={"http://www.salvamontromania.ro"}
                            biggerCursor={biggerCursor}
                            target="_blank"
                          >
                            <CustomText
                              type={TextType.H5}
                              text={t("components.footer.card3.SR")}
                              color={COLORS.Cultured}
                            />
                          </LinkWrapper>
                        </ColumnThirdCard>
                      </RowThirdCard>
                      {isMobile && <HorizontalLine />}

                      <DsuWrapper>
                        <CustomText
                          text={"© " + t("components.footer.card3.DSU")}
                          type={TextType.H5}
                          color={COLORS.Cultured}
                        />
                      </DsuWrapper>
                    </ThirdCard>
                  </ColumnOne>
                  <Column>
                    <FourthCard
                      biggerCursor={biggerCursor}
                      onClick={() => scrollToTop()}
                      tabIndex={0}
                    >
                      <Title>{t("components.footer.card5.back")}</Title>
                      <Lottie
                        animationData={animationData}
                        style={lottieStyle}
                      />
                    </FourthCard>
                    <MiddleCard tabIndex={0}>
                      <TitleMedium>
                        <CustomText
                          type={TextType.H3}
                          text={t("components.footer.card2.contact")}
                          color={COLORS.Yellow}
                        />
                      </TitleMedium>
                      <ContactStyled>
                        <StyledLink
                          biggerCursor={biggerCursor}
                          href={`tel:${t("components.footer.card6.phone")}`}
                        >
                          <CustomText
                            type={TextType.H4bold}
                            text={t("components.footer.card6.phone")}
                            color={COLORS.Cultured}
                          />
                        </StyledLink>
                        <StyledLink
                          biggerCursor={biggerCursor}
                          href={`tel:${t("components.footer.card6.central")}`}
                        >
                          <CustomText
                            type={TextType.H4bold}
                            text={t("components.footer.card6.central")}
                            color={COLORS.Cultured}
                          />
                        </StyledLink>
                        <StyledLink
                          biggerCursor={biggerCursor}
                          href={`mailto:${t("components.footer.card6.email")}`}
                        >
                          <CustomText
                            type={TextType.H4bold}
                            text={t("components.footer.card6.email")}
                            color={COLORS.Cultured}
                          />
                        </StyledLink>
                      </ContactStyled>
                      <SocialWrapper>
                        <SocialCard>
                          <LinkWrapper
                            href={"https://www.youtube.com/@DSU9979"}
                            biggerCursor={biggerCursor}
                            target="_blank"
                          >
                            <SocialIcon
                              src={YoutubeIcon}
                              alt="YouTube"
                              biggerCursor={biggerCursor}
                            />
                          </LinkWrapper>
                        </SocialCard>
                        <SocialCard>
                          <LinkWrapper
                            href={
                              "https://www.facebook.com/departamenturgente/?locale=ro_RO"
                            }
                            biggerCursor={biggerCursor}
                            target="_blank"
                          >
                            <SocialIcon
                              src={FacebookIcon}
                              alt="Facebook"
                              biggerCursor={biggerCursor}
                            />
                          </LinkWrapper>
                        </SocialCard>
                        <SocialCard>
                          <LinkWrapper
                            href={
                              "https://instagram.com/dsu_romania?igshid=OGQ5ZDc2ODk2ZA%3D%3D&utm_source=qr"
                            }
                            biggerCursor={biggerCursor}
                            target="_blank"
                          >
                            <SocialIcon
                              src={InstagramIcon}
                              alt="instagram"
                              biggerCursor={biggerCursor}
                            />
                          </LinkWrapper>
                        </SocialCard>
                      </SocialWrapper>
                    </MiddleCard>
                    <MediumCard tabIndex={0}>
                      <IconCard>
                        <SiglaIcon src={SiglaISO} alt="siglaISO" />
                      </IconCard>
                      <IconCard>
                        <SiglaIcon src={SiglaSMC} alt="siglaSMC" />
                      </IconCard>
                    </MediumCard>
                  </Column>
                </>
              )}
            </Row>
          </Column>
          {!isTablet && (
            <Column>
              <FourthCard
                biggerCursor={biggerCursor}
                onClick={() => scrollToTop()}
                tabIndex={0}
              >
                <Title>{t("components.footer.card5.back")}</Title>
                <Lottie animationData={animationData} style={lottieStyle} />
              </FourthCard>
              <MiddleCard tabIndex={0}>
                <TitleMedium>
                  <CustomText
                    type={TextType.H3}
                    text={t("components.footer.card2.contact")}
                    color={COLORS.Yellow}
                  />
                </TitleMedium>
                <ContactStyled>
                  <StyledLink
                    biggerCursor={biggerCursor}
                    href={`tel:${t("components.footer.card6.phone")}`}
                  >
                    <CustomText
                      type={TextType.H4bold}
                      text={t("components.footer.card6.phone")}
                      color={COLORS.Cultured}
                    />
                  </StyledLink>
                  <StyledLink
                    biggerCursor={biggerCursor}
                    href={`tel:${t("components.footer.card6.central")}`}
                  >
                    <CustomText
                      type={TextType.H4bold}
                      text={t("components.footer.card6.central")}
                      color={COLORS.Cultured}
                    />
                  </StyledLink>
                  <StyledLink
                    biggerCursor={biggerCursor}
                    href={`mailto:${t("components.footer.card6.email")}`}
                  >
                    <CustomText
                      type={TextType.H4bold}
                      text={t("components.footer.card6.email")}
                      color={COLORS.Cultured}
                    />
                  </StyledLink>
                </ContactStyled>
                <SocialWrapper tabIndex={0}>
                  <SocialCard>
                    <LinkWrapper
                      href={"https://www.youtube.com/@DSU9979"}
                      biggerCursor={biggerCursor}
                      target="_blank"
                    >
                      <SocialIcon
                        src={YoutubeIcon}
                        alt="YouTube"
                        biggerCursor={biggerCursor}
                      />
                    </LinkWrapper>
                  </SocialCard>
                  <SocialCard>
                    <LinkWrapper
                      href={
                        "https://www.facebook.com/departamenturgente/?locale=ro_RO"
                      }
                      biggerCursor={biggerCursor}
                      target="_blank"
                    >
                      <SocialIcon
                        src={FacebookIcon}
                        alt="Facebook"
                        biggerCursor={biggerCursor}
                      />
                    </LinkWrapper>
                  </SocialCard>
                  <SocialCard>
                    <LinkWrapper
                      href={
                        "https://instagram.com/dsu_romania?igshid=OGQ5ZDc2ODk2ZA%3D%3D&utm_source=qr"
                      }
                      biggerCursor={biggerCursor}
                      target="_blank"
                    >
                      <SocialIcon
                        src={InstagramIcon}
                        alt="instagram"
                        biggerCursor={biggerCursor}
                      />
                    </LinkWrapper>
                  </SocialCard>
                </SocialWrapper>
              </MiddleCard>
              <MediumCard>
                <IconCard>
                  <SiglaIcon src={SiglaISO} alt="siglaISO" />
                </IconCard>
                <IconCard>
                  <SiglaIcon src={SiglaSMC} alt="siglaSMC" />
                </IconCard>
              </MediumCard>
            </Column>
          )}
        </GridContainer>
      </BigContainer>
    </>
  );
};

export default Footer;
